import { type FC } from "react";

import { Skeleton } from "@snapchat/snap-design-system";

import { useHorizontalChartData } from "../../../hooks";
import { type CountriesStatsItem } from "../../../models";
import { StatsEmptyState } from "../../shared";

import { HorizontalBarChartItem } from "./HorizontalBarChartItem";
import { SeeMoreButton } from "./SeeMoreButton";

export const HorizontalBarChart: FC<{ stats: readonly CountriesStatsItem[]; loading: boolean }> = ({
    stats,
    loading,
}) => {
    const { metricsList, seeMoreActive, seeMoreVisible, onClickSeeMore } = useHorizontalChartData(stats);

    if (loading) {
        return <Skeleton height={40} paragraph={5} />;
    }

    if (stats.length === 0) {
        return (
            <StatsEmptyState
                title="Not enough Data"
                description="Insights breakdown will be available when your Lens(es) get enough Reach"
            />
        );
    }

    return (
        <>
            {metricsList.map(({ key, value, pct, width }) => (
                <HorizontalBarChartItem key={key} country={key} value={value} pct={pct} width={width} />
            ))}

            <SeeMoreButton isActive={seeMoreActive} isVisible={seeMoreVisible} onClick={onClickSeeMore} />
        </>
    );
};
